import { Pipe, PipeTransform } from '@angular/core';
import { IncidentStatus } from 'app/shared/api/generated/v2/incident';

@Pipe({
    name: 'endIncidentStatusLabel',
    standalone: false
})
export class EndIncidentStatusLabelPipe implements PipeTransform {

  private readonly incidentStatusLabel: {} = {
    [IncidentStatus.FaultFixed]: {
      internal: 'Störung behoben',
      external: 'Störung behoben'
    },
    [IncidentStatus.FaultNotFound]: {
      internal: 'Keine Störung vorgefunden',
      external: 'Keine Störung vorgefunden'
    },
    [IncidentStatus.FaultFixedProvisionalSolution]: {
      internal: 'Störung behoben (Provisorium)',
      external: 'Störung behoben'
    },
    [IncidentStatus.Aborted]: {
      internal: 'Abgebrochen',
      external: 'Störung behoben'
    },
    [IncidentStatus.PoleNotAccessible]: {
      internal: 'Mast nicht zugänglich',
      external: 'Mast nicht zugänglich (Folgemaßnahmen Kommune)'
    },
    [IncidentStatus.Unrepairable]: {
      internal: 'Irreparabel',
      external: 'Kontaktaufnahme durch Fachvertrieb'
    },
  };

  transform(value: IncidentStatus, returnStatusType: 'internal' | 'external'): string {
    const statusLabel = this.incidentStatusLabel[value];
    return returnStatusType === 'internal' ? statusLabel.internal : statusLabel.external;
  }
}
